import { isType } from '@src/utils';
import { requiredValidate } from '../utils';
import { indexDB, utils } from 'ynf-core-middleware';
import { add } from '.';
import DraftSelect from '@src/components/draftSelect';
import React from 'react';
const { formatUtils } = utils;

/**
 * 保存草稿
 * @param rootStore 
 * @param options {
 *  // 必填字段
 *  cardStoreKey: string， 默认值：cardStore
 *  // 选填字段
 *  billNo: string， 默认值：params.billNo
 *  dbName: string， 默认值：yonbuilder_db
 *  tableName: string， 默认值：draft
 * }
 * @hooks {
 *  // 专有钩子
 *  // 公共钩子 
 *  beforeHook: 开始钩子 
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export async function saveDraft(rootStore: any, options: any = {}) {
  requiredValidate.call(this, options, ['cardStoreKey']);
  const { cardStoreKey = 'cardStore', dbName = 'yonbuilder_db', tableName = 'draft' } = options;
  const { utils = {}, pageStore = {}, context = {} } = rootStore;
  const { params = {}, query = {} } = pageStore;
  const cardStore = rootStore.get(cardStoreKey);
  if (!cardStore) throw (new Error(`The CardStore[${cardStoreKey}] not found`));
  const billNo = options.billNo || params.billNo;
  const { userid = '', tenantid = '', username = '' } = context;
	if (!userid) throw (new Error(`The Context.userid not found`));
	if (!tenantid) throw (new Error(`The Context.tenantid not found`));
	if (!billNo) throw (new Error(`The Params.billNo not found`));
  const nowts = Date.now();
  const storeKey = `${userid}/${tenantid}/${billNo}`;
  const data = cardStore.getValue({ dirtyCheck: false });
  const title = `${lang.localeUuid('UID:P_CORE-YNF-FE_18952C6C05B80007', { time: formatUtils.formatDate(nowts,'yyyy/MM/dd hh:mm:ss'), returnStr: true})}${formatUtils.formatDate(nowts,'yyyy/MM/dd hh:mm:ss')}`;// 草稿【<%=time%>】
	
  try {
		const ybDBInstance = await indexDB.init(dbName, 1, [{ tableName, options: { keyPath: "id", autoIncrement: true }}]);
		const jsonData = JSON.stringify(data)?.replace?.(/("id\\*":\\*)"[^"]+(\\*)"/g, '$1null$2');
		const res = await ybDBInstance.query(tableName, (v: any) => v.key === storeKey); // res.sort((v1: any, v2: any) => v2.id - v1.id)
		const lastItem = res[res.length-1];
		if (lastItem?.data === jsonData) {
			await rootStore.utils.confirm({ title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80051', '确认保存为草稿?'), content: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80052', '检测到您的草稿未发生变化，是否继续保存为新的草稿'), ...options.confirmOptions });
		}
    await ybDBInstance.insert(tableName, { key: storeKey, billNo, username, ts: nowts, id: nowts, title, data: jsonData });
    await ybDBInstance.delete(tableName, (v: any) => (v.key === storeKey && v.id < (nowts - 3 * 24 * 60 * 60 * 1000)));
    utils.message.success({ content: lang.localeUuid('UID:P_CORE-YNF-FE_18952DB004500003', { time: formatUtils.formatDate(nowts,'yyyy/MM/dd hh:mm:ss') }), duration: 8 });// 时间【<%=time%>】，当前单据状态，为您保存为草稿
  } catch (err: any) {
		utils.message.danger(err?.message);
    return Promise.reject(err);
	}
}

/**
 * 草稿新增
 * @param rootStore 
 * @param options {
 *  // 必填字段
 *  // 选填字段
 *  billNo: string， 默认值：params.billNo
 *  dbName: string， 默认值：yonbuilder_db
 *  tableName: string， 默认值：draft
 * }
 * @hooks {
 *  // 专有钩子
 *  // 公共钩子 
 *  beforeHook: 开始钩子 
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export async function draftAdd(rootStore: any, options: any = {}, event: any = {}, eventOptions: any = {}) {
  const { dbName = 'yonbuilder_db', tableName = 'draft' } = options;
  const { utils = {}, pageStore = {}, context = {} } = rootStore;
  const { params = {}, query = {} } = pageStore;
  const billNo = options.billNo || params.billNo;
  const { userid = '', tenantid = '' } = context;
	if (!userid) throw (new Error(`The Context.userid not found`));
	if (!tenantid) throw (new Error(`The Context.tenantid not found`));
	if (!billNo) throw (new Error(`The Params.billNo not found`));
  let { id = '', data = '' } = eventOptions;
  try {
    pageStore?.startLoading?.();
    if (!data) {
      if (!id) {
        throw new Error('不存在此草稿，新增异常');//@notranslate
      }
      const ybDBInstance = await indexDB.init(dbName, 1, [{ tableName, options: { keyPath: "id", autoIncrement: true }}]);
      const res = await ybDBInstance.query(tableName, (v: any) => v.id == id); 
      data = res?.[0]?.['data'];
    }
    if (isType(data, 'String')) {
      data = JSON.parse(data);
    }
    if (!data) {
      throw new Error('不存在此草稿，新增异常');//@notranslate
    }
    // add 请求
    const addRes = await add.call(this, rootStore, { ...options, data });
    return addRes;
  } catch (err: any) {
    utils.message.danger(err?.message || lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80053', '草稿新增异常'));
    return Promise.reject(err);
  } finally {
    pageStore?.endLoading?.();
  }
}

/**
 * 选择草稿并新增
 * @param rootStore 
 * @param options {
 *  // 必填字段
 *  // 选填字段
 *  billNo: string， 默认值：params.billNo
 *  dbName: string， 默认值：yonbuilder_db
 *  tableName: string， 默认值：draft
 * }
 * @hooks {
 *  // 专有钩子
 *  // 公共钩子 
 *  beforeHook: 开始钩子 
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export const draftSelectAndAdd = {
  async doAction(rootStore: any, options: any = {}) {
    let { dbName = 'yonbuilder_db', tableName = 'draft' } = options;
    const { utils = {}, pageStore = {}, context = {} } = rootStore;
    const { params = {}, query = {} } = pageStore;
    const billNo = options.billNo || params.billNo;
    const { userid = '', tenantid = '' } = context;
    if (!userid) throw (new Error(`The Context.userid not found`));
    if (!tenantid) throw (new Error(`The Context.tenantid not found`));
    if (!billNo) throw (new Error(`The Params.billNo not found`));
    const storeKey = `${userid}/${tenantid}/${billNo}`;
    try {
      // beforeDBQueryHook
      if (isType(this.beforeDBQueryHook, 'Function')) {
        ({ dbName, tableName } = await this.beforeDBQueryHook(rootStore, { dbName, tableName }));
      }
      const ybDBInstance = await indexDB.init(dbName, 1, [{ tableName, options: { keyPath: "id", autoIncrement: true }}]);
      let res = await ybDBInstance.query(tableName, (v: any) => v.key == storeKey); 
      // afterDBQueryHook
      if (isType(this.afterDBQueryHook, 'Function')) {
        res = await this.afterDBQueryHook(rootStore, res);
      }
      pageStore.openModal({
        uiType: "component",
        title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80050', '选择草稿'),
        bodyStyle: { 
          width: '800px', 
          height: '500px' 
        },
        component: (<DraftSelect 
          data={ res.map((v: any) => Object.assign(v, { key: v.id })).sort((v1: any, v2: any) => v2.ts - v1.ts) }
          onConfirm={(data = []) => {
            if (data.length) draftAdd.call(this, rootStore, { ...options, dbName, tableName }, null, data[0]);
            pageStore.closeModal({ uiType: 'component' });
          }}
          onCancel={() => {
            pageStore.closeModal({ uiType: 'component' });
          }}
        />)
     })
    } catch (err: any) {
      utils.message.danger(err?.message || lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6005B80053', '草稿新增异常'));
      return Promise.reject(err);
    } finally {
      pageStore?.endLoading?.();
    }
  }
}


